/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsAppStore } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { Observable } from "rxjs";
import { tap } from "rxjs";
import { filter } from "rxjs";
import { ANVILOR_SURVEYS_FAVICON_PATH } from "../../consts";
import { WindowService } from "@anvilor/ngx-apps-core";

export class AnvilorFormsAppWindowBinding {
  private window: WindowService;
  private store: AnvilorFormsAppStore;
  private windowTitle$: Observable<string>;
  private faviconPath$: Observable<string>;

  constructor(private ctx: AnvilorFormsAppStoreContext) {
    this.window = ctx.window;
    this.store = ctx.store;
    this.faviconPath$ = this.store.selectFromDisplayConfig(
      (c) => c.web_favicon ?? ANVILOR_SURVEYS_FAVICON_PATH
    );
    this.windowTitle$ = this.store.selectFromDisplayConfig(
      (c) => c.web_title ?? "Anvilor Form"
    );
  }

  bindToWindow() {
    this.store.subscribeTo(
      this.windowTitle$.pipe(tap((title) => this.window.setTitle(title)))
    );

    this.store.subscribeTo(
      this.faviconPath$.pipe(
        filter((path) => !!path),
        tap((path) => this.window.setFavicon(path))
      )
    );
  }
}
